import * as ordersConstant from './constants'

export const ordersListNvRequest = function ordersListNvRequest (formData, callback) {  
  return {
    type: ordersConstant.ORDERS_LIST_NV_REQUESTING,
    formData,
    callback
  }
}

export const ordersListNvSuccess = function ordersListNvSuccess (data) {  
  return {
    type: ordersConstant.ORDERS_LIST_NV_SUCCESS,
    data
  }
}

export const ordersListNvError = function ordersListNvError (error) {  
  return {
    type: ordersConstant.ORDERS_LIST_NV_ERROR,
    error
  }
}

export const ordersListRequest = function ordersListRequest (formData) {  
  return {
    type: ordersConstant.ORDERS_LIST_REQUESTING,
    formData
  }
}

export const ordersListSuccess = function ordersListSuccess (data) {  
  return {
    type: ordersConstant.ORDERS_LIST_SUCCESS,
    data
  }
}

export const ordersListError = function ordersListError (error) {  
  return {
    type: ordersConstant.ORDERS_LIST_ERROR,
    error
  }
}

export const ordersRemoveItemRequest = function ordersRemoveItemRequest (formData, callback) {  
  return {
    type: ordersConstant.ORDERS_REMOVE_ITEM_REQUESTING,
    formData, 
    callback
  }
}

export const ordersRemoveItemSuccess = function ordersRemoveItemSuccess (data) {  
  return {
    type: ordersConstant.ORDERS_REMOVE_ITEM_SUCCESS,
    data
  }
}

export const ordersRemoveItemError = function ordersRemoveItemError (error) {  
  return {
    type: ordersConstant.ORDERS_REMOVE_ITEM_ERROR,
    error
  }
}

export const ordersKhachHangRequest = (formData) => {  
  return {
    type: ordersConstant.ORDERS_KHACHHANG_REQUESTING,
    payload: formData
  }
}

export const ordersKhachHangSuccess = function ordersKhachHangSuccess (data) {  
  return {
    type: ordersConstant.ORDERS_KHACHHANG_SUCCESS,
    data
  }
}

export const ordersKhachHangError = function ordersKhachHangError (error) {  
  return {
    type: ordersConstant.ORDERS_KHACHHANG_ERROR,
    error
  }
}
export const ordersDaiLyRequest = function ordersDaiLyRequest (formData) {  
  return {
    type: ordersConstant.ORDERS_DAILY_REQUESTING,
    formData
  }
}

export const ordersDaiLySuccess = function ordersDaiLySuccess (data) {  
  return {
    type: ordersConstant.ORDERS_DAILY_SUCCESS,
    data
  }
}

export const ordersDaiLyError = function ordersDaiLyError (error) {  
  return {
    type: ordersConstant.ORDERS_DAILY_ERROR,
    error
  }
}

export const ordersExportXlsRequest = (formData, onSuccess) => {
  return {
    type: ordersConstant.ORDERS_EXPORT_XLS_REQUESTING,
    payload: formData,
    onSuccess
  }
}

export const ordersExportXlsSuccess = () => {
  return {
    type: ordersConstant.ORDERS_EXPORT_XLS_SUCCESS,
  }
}

export const ordersExportXlsError = function ordersExportXlsError(error) {
  return {
    type: ordersConstant.ORDERS_EXPORT_XLS_ERROR,
    error
  }
}

export const setOrdersApproveList = (data) => {
  return {
    type: ordersConstant.ORDERS_APPROVE_SET_LIST,
    payload: data
  }
}
export const postApproveOrders = (data, callback) => {
  return {
    type: ordersConstant.ORDERS_APPROVE_LIST_REQUESTING,
    payload: data,
    callback
  }
}
export const setApproveMessage = (msg) => {
  return {
    type: ordersConstant.ORDERS_SET_APPROVE_MESSAGE,
    payload: msg
  }
}
export const setApproveError = (error) => {
  return {
    type: ordersConstant.ORDERS_SET_APPROVE_ERROR,
    payload: error
  }
}


// WEBPACK FOOTER //
// ./src/views/Orders/actions.js